import { execute } from '@/api/execute'
import { GET, PUT } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'dashboard/clients'
const ENDPOINT_V2 = 'v2/dashboard/clients'

export default {
  // v1 endpoints
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },
  clientList (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/list/`, params))
  },
  clientsFarms (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/farms/`, params))
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  getFarmsById (id) {
    return execute(GET, `${ENDPOINT}/${id}/manager/farms/dashboard/`)
  },
  getFarmsByIdV2 (id, params) {
    return execute(GET, addQueryParams(`${ENDPOINT_V2}/${id}/manager/farms/dashboard/`, params))
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  // v2 endpoints
  listV2 (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT_V2}/`, params))
  },

  getByIdV2 (id) {
    return execute(GET, `${ENDPOINT_V2}/${id}/`)
  },

  updateByIdV2 (id, payload) {
    return execute(PUT, `${ENDPOINT_V2}/${id}/`, payload)
  },
  getLeftoversById (id, params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/${id}/leftovers/`, params))
  },
  updateLeftoversById (id, leftoverId, params = {}) {
    return execute(PUT, `${ENDPOINT}/${id}/leftovers/${leftoverId}/`, params)
  }

}
